import { gql } from "@apollo/client";

export const FIND_ALL_CRISIS_MANAGEMENT_TEAMS_BY_PLAN = gql`
  query FindAllCrisisManagementTeamsByPlan($uuid: ID!) {
    findAll: findAllCrisisManagementTeamsByPlan(uuid: $uuid) {
      backUpEmail
      backUpFirstName
      backUpLastName
      backUpPhone
      email
      firstName
      lastName
      phone
      role
      uuid
    }
  }
`;

export const CREATE_CRISIS_MANAGEMENT_TEAM = gql`
  mutation CreateCrisisManagementTeam($data: CreateCrisisManagementTeamInput!) {
    createCrisisManagementTeam(data: $data) {
      backUpEmail
      backUpFirstName
      backUpLastName
      backUpPhone
      email
      firstName
      lastName
      phone
      role
      uuid
    }
  }
`;

export const UPDATE_CRISIS_MANAGEMENT_TEAM = gql`
  mutation UpdateCrisisManagementTeam($data: UpdateCrisisManagementTeamInput!) {
    updateCrisisManagementTeam(data: $data) {
      backUpEmail
      backUpFirstName
      backUpLastName
      backUpPhone
      email
      firstName
      lastName
      phone
      role
      uuid
    }
  }
`;

export const DELETE_CRISIS_MANAGEMENT_TEAM = gql`
  mutation DeleteCrisisManagementTeam($uuid: ID!) {
    deleteCrisisManagementTeam(uuid: $uuid) {
      backUpEmail
      backUpFirstName
      backUpLastName
      backUpPhone
      email
      firstName
      lastName
      phone
      role
      uuid
    }
  }
`;